module.exports = __webpack_public_path__ + "media/customizations/riverlights/logo-365177d8dd0852c4c5f903d411ae550c.png";